/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom"; // Add these
import { FiChevronDown } from "react-icons/fi";
import { setLanguage } from "../../actions/admin/settings";
/**This is the hovering language card used to switch the language.
 * @param {boolean} dropUp - open the menu above the button (used by the floating bottom-right card)
 */
const LanguageCard = ({
  langChangeCallback = () => { },
  dropUp = false,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close the dropdown when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  // const [language, setLanguage] = useState("JP");
  const LANG_ROUTES = [
    "/",
    "/work",
    "/book",
    "/fleet",
    "/pricing",
    "/services",
    "/fleet-types",
    "/cancellation-policy",
    "/maps",
  ];

  const langChange = (newLng) => {
    setOpen(false);
    const storageLng = newLng.toUpperCase(); // EN / JP
    const urlLng = newLng.toLowerCase();     // en / jp

    i18n.changeLanguage(urlLng);
    localStorage.setItem("lang", storageLng);
    dispatch(setLanguage(storageLng));

    const pathParts = location.pathname.split("/");
    const currentLangInUrl = pathParts[1]?.toLowerCase();

    const pathnameWithoutLang =
      currentLangInUrl === "en" || currentLangInUrl === "jp"
        ? "/" + pathParts.slice(2).join("/")
        : location.pathname;

    const isLangRoute = LANG_ROUTES.some(
      (route) =>
        pathnameWithoutLang === route ||
        pathnameWithoutLang.startsWith(route + "/")
    );

    // 🚨 IMPORTANT: Only update URL for language-prefixed routes
    if (!isLangRoute) {
      if (langChangeCallback) langChangeCallback(storageLng);
      return;
    }

    let newPath;

    if (currentLangInUrl === "en" || currentLangInUrl === "jp") {
      pathParts[1] = urlLng;
      newPath = pathParts.join("/");
    } else {
      newPath = `/${urlLng}${location.pathname}`;
    }

    history.push(newPath + location.search);

    if (langChangeCallback) langChangeCallback(storageLng);
  };

  useEffect(() => {
    // Check if the current URL has a language that conflicts with state
    const pathParts = location.pathname.split("/");
    const urlLang = pathParts[1]?.toLowerCase();
    const storedLang = localStorage.getItem("lang")?.toLowerCase();

    if ((urlLang === "en" || urlLang === "jp") && urlLang !== storedLang) {
      // Sync state to URL if user manually typed a different lang in address bar
      i18n.changeLanguage(urlLang);
      localStorage.setItem("lang", urlLang.toUpperCase());
      dispatch(setLanguage(urlLang.toUpperCase()));
    }
  }, [location.pathname]);
  return (
    <div className="tw:relative tw:inline-flex" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        className="tw:h-[45px] tw:!flex tw:items-center tw:gap-[7px] tw:!bg-[#333333] tw:!text-white tw:font-hanken-grotesk tw:!font-bold tw:!text-base tw:!min-w-fit tw:!px-4 tw:!py-2 tw:lg:!ml-3 tw:!mr-2 tw:lg:!mr-0 tw:!rounded tw:border-0 tw:!cursor-pointer"
      >
        <span className="tw:inline-flex">
          <i className="bi bi-globe"></i>{" "}
        </span>
        <span className="tw:!font-hanken-grotesk tw:text-white tw:font-medium tw:text-base">
          {i18n.language.toUpperCase()}{" "}
        </span>{" "}
        <FiChevronDown
          color="#ffffff"
          className={`tw:transition-transform ${open ? "tw:rotate-180" : ""}`}
        />
      </button>

      {open && (
        <ul
          className={`tw:absolute tw:right-0 tw:min-w-[10rem] tw:!px-0 tw:bg-white tw:border tw:border-[rgba(0,0,0,0.15)] tw:rounded-lg tw:shadow-lg tw:py-2 tw:z-50 tw:list-none tw:!m-0 ${dropUp ? "tw:bottom-full tw:mb-1" : "tw:top-full tw:mt-1"}`}
        >
          <li>
            <button
              className="tw:block tw:w-full tw:text-left tw:px-4 tw:py-2 tw:bg-transparent tw:border-0 tw:cursor-pointer tw:font-hanken-grotesk tw:!text-[#4E4E4E] tw:!text-[14px] tw:!font-[400] tw:hover:!bg-[#f8f9fa]"
              onClick={() => langChange("EN")}
            >
              {t("LangCard.English")}
            </button>
          </li>
          <li>
            <button
              className="tw:block tw:w-full tw:text-left tw:px-4 tw:py-2 tw:bg-transparent tw:border-0 tw:cursor-pointer tw:font-hanken-grotesk tw:!text-[#4E4E4E] tw:!text-[14px] tw:!font-[400] tw:hover:!bg-[#f8f9fa]"
              onClick={() => langChange("JP")}
            >
              {t("LangCard.Japanese")}
            </button>
          </li>
        </ul>
      )}
    </div>
  );
};

export default LanguageCard;
